module.exports = __webpack_public_path__ + "static/media/나.848ba1fa.jpg";